import React from 'react'
import { Header } from '../../components/SpearParts/Layouts/Header'
import { SeachSection } from '../../components/SpearParts/Layouts/SeachSection'

export default function Product() {
  const sectionStyle = {
    backgroundImage: "url('images/slide1.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    
  };
  return (
    <div>
      
   
                <Header />
                  <section id="inner-banner">
                            <div class="container">
                             
                                <div id="banner">
                                <div className="banner" style={sectionStyle}>
                                  </div>
                                  </div>
                              
                                </div>
                               
                                </section>
    </div>
  )
}
